import { Inject, Injectable } from '@angular/core';
import {
  CampaignHashtagPosts,
  CampaignHashtagPostsRepository
} from '@infrab4a/connect';
import { ConnectRequest } from 'src/app/models';
import { BaseConnectService } from './base-connect.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignHashtagPostsService extends BaseConnectService<CampaignHashtagPosts> {
  constructor(
    @Inject('CampaignHashtagPostsRepository')
    private campaignHashtagPostsRepository: CampaignHashtagPostsRepository
  ) {
    super(campaignHashtagPostsRepository);
  }

  async getPostById(id: string): Promise<CampaignHashtagPosts> {
    return this.campaignHashtagPostsRepository.get({ id });
  }

  async getPostsList(request: Partial<ConnectRequest>) {
    const filters = this.getFiltersQuery(request.filters);
    const hasFilters = !!filters && Object.keys(filters).length > 0;
    const result = await this.campaignHashtagPostsRepository.find({
      ...(hasFilters && { filters }),
      options: {
        enableCount: true
      }
    });
    const allItems = (result.data ?? []).map((post) => ({ ...post }));
    const totalElements = allItems.length;
    const content = this.paginate(allItems, request.page, request.pageSize);

    return {
      totalPages: request.pageSize
        ? Math.floor(totalElements / request.pageSize)
        : undefined,
      totalElements,
      content,
      empty: totalElements === 0
    };
  }

  async savePost(post: Partial<CampaignHashtagPosts>) {
    const now = new Date();
    return this.campaignHashtagPostsRepository.create(
      CampaignHashtagPosts.toInstance({
        ...post,
        createdAt: post.createdAt ?? now,
        updatedAt: now
      })
    );
  }

  async updatePost(post: Partial<CampaignHashtagPosts>) {
    const now = new Date();
    return this.campaignHashtagPostsRepository.update(
      CampaignHashtagPosts.toInstance({
        ...post,
        updatedAt: now,
        postEvaluationDate: post.postEvaluationDate ?? now
      })
    );
  }

  private paginate<T>(
    items: T[],
    page?: number,
    pageSize?: number
  ): T[] {
    if (!pageSize) {
      return items;
    }

    const start = (page ?? 0) * pageSize;
    return items.slice(start, start + pageSize);
  }
}
